var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMotif23(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16.0001,
    height: 15.9955,
    viewBox: "0 0 16.0001 15.9955",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 0.000117478V7.99779C8 12.4147 4.41827 15.9955 0 15.9955V7.99779C0 3.58083 3.58173 0.000117478 8 0.000117478Z",
    fill: "#D4623A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.0001 15.9953V7.99767C16.0001 3.58072 12.4183 0 8.00006 0V7.99767C8.00006 12.4146 11.5818 15.9953 16.0001 15.9953Z",
    fill: "#274766"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotif23);
export default __webpack_public_path__ + "static/media/motif-23.8c4f195dc4b20f378287dc3440451d63.svg";
export { ForwardRef as ReactComponent };